import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';

import { FAIcon } from '../../../../components/adapters/fontAwesomeAdapters';
import AdminConsoleSection, {
  AdminConsoleSectionContent,
  AdminConsoleSectionTitleHeader,
} from '../../components/AdminConsoleSection';
import { formatAccountLabel } from '../../utils/adminFormatting';
import { AccountBusinessTypeField } from './AdminAccountDetailCommon';
import { useAdminAccountProfileCardStyles } from './AdminAccountProfileCard.styles';
import AdminAccountProfileButtons from './AdminAccountProfileButtons';
import { AccountCompanyInformationSection } from './accountProfileSections';

export default function AdminAccountProfileCard({
  account,
  viewMode,
  setViewMode,
  initialValues,
  visible,
  sectionHomeRoute,
  formToGraphql,
}) {
  const { styles } = useAdminAccountProfileCardStyles();

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.card}>
      <Row className={styles.titleRow} align="middle" justify="space-between">
        <Col>
          <div className={styles.title}>
            <FAIcon icon="file-invoice" className="icon-19" />
            <span>
              <FormattedMessage id="admin.accountManagement.accountDetail.accountProfile" />
            </span>
          </div>
        </Col>
        <Col>
          <AdminAccountProfileButtons
            viewMode={viewMode}
            setViewMode={setViewMode}
            initialValues={initialValues}
            sectionHomeRoute={sectionHomeRoute}
            formToGraphql={formToGraphql}
          />
        </Col>
      </Row>

      <AdminConsoleSection>
        <AdminConsoleSectionTitleHeader>
          <span className={styles.accountLabel}>
            {formatAccountLabel(account, { long: true })}
          </span>
          <AccountBusinessTypeField readOnly />
        </AdminConsoleSectionTitleHeader>
        <AdminConsoleSectionContent>
          <AccountCompanyInformationSection account={account} />
        </AdminConsoleSectionContent>
      </AdminConsoleSection>
    </div>
  );
}
